import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WaitCursorService {
  private counter: number = 0;

  private readonly className: string = 'app-request-waiting';

  private timeoutId: number | null = null;

  private isActive: boolean = false;

  private readonly minDelay: number = 200;

  start (): void {
    this.counter++;

    if (this.counter === 1 && !this.timeoutId) {
      this.timeoutId = window.setTimeout(() => {
        document.body.classList.add(this.className);
        this.isActive = true;
        this.timeoutId = null;
      }, this.minDelay);
    }
  }

  stop (): void {
    if (this.counter > 0)
      this.counter--;

    if (this.counter === 0) {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      if (this.isActive) {
        document.body.classList.remove(this.className);
        this.isActive = false;
      }
    }
  }

  reset (): void {
    this.counter = 0;

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    if (this.isActive) {
      document.body.classList.remove(this.className);
      this.isActive = false;
    }
  }
}

